import { useMutation, useQuery } from '@tanstack/react-query';

import { EQueryKeys } from '../../constants/enums';
import useAxios from '../../hooks/useAxios';
import { EApiRoutes, getApiRouteOrMock } from '../api.utils';

import { FinancialConfigData,PaymentMethod } from './payments.types';

export default function usePayments() {
  const axios = useAxios();

  const getPaymentMethods = useQuery<PaymentMethod[], Error>({
    queryKey: [EQueryKeys.PAYMENTS],
    queryFn: async () => {
      return await axios.get(getApiRouteOrMock(EApiRoutes.PAYMENTS));
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false
  });

  const getFinancialConfiguration = useQuery<FinancialConfigData, Error>({
    queryKey: [EQueryKeys.FINANCIAL_CONFIGURATION],
    queryFn: async () => {
      return await axios.get(getApiRouteOrMock(EApiRoutes.FINANCIAL_CONFIGURATION));
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false
  });

  const updatePaymentMethods = useMutation(
    async (paymentMethods: Partial<FinancialConfigData>) => {
      try {
        const response = await axios.put(
          getApiRouteOrMock(EApiRoutes.FINANCIAL_CONFIGURATION),
          paymentMethods
        );
        return response.data;
      } catch (error: any) {
        if (error.response) {
          throw error;
        }
      }
    },
    {}
  );

  return {
    getPaymentMethods,
    getFinancialConfiguration,
    updatePaymentMethods,
  };
}
